import { createContext, useContext } from 'react'
import { CapturedWineQuery } from 'api/operations'

type CapturedWineData = NonNullable<CapturedWineQuery['capturedWine']>

interface CapturedWineContextValue {
  capturedWine: CapturedWineData
  isAuthor: boolean
  isTransitional: boolean
  authorUserId: string | null
  getCapturedWineUrl?: (id: string) => string
  canEdit?: boolean
}

export const CapturedWineContext = createContext<CapturedWineContextValue>(
  null as any
)

export const useCapturedWine = () => useContext(CapturedWineContext)
